(() => {
  'use strict';
  document.querySelectorAll('.lmb-cart [data-cart-count]').forEach((counter) => {
    const sync = () => { counter.hidden = Number(counter.textContent.trim()) === 0; };
    sync();
    new MutationObserver(sync).observe(counter, { childList: true, characterData: true, subtree: true });
  });
  document.addEventListener('click', (event) => {
    const navLink = event.target.closest('.lmb-mobile-nav a');
    if (navLink) navLink.closest('details').open = false;
  });
})();
